import { render, staticRenderFns } from "./ReminderPublicModal.vue?vue&type=template&id=7a52b0ad&scoped=true&"
import script from "./ReminderPublicModal.vue?vue&type=script&lang=js&"
export * from "./ReminderPublicModal.vue?vue&type=script&lang=js&"
import style0 from "./ReminderPublicModal.vue?vue&type=style&index=0&id=7a52b0ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a52b0ad",
  null
  
)

export default component.exports